// extracted by mini-css-extract-plugin
module.exports = {"analysis":"Analysis_analysis__3G5Qj"};